import React from "react";
import { css } from "emotion";
import { boxStyles, textSizes, colors } from "../../styles/theme";
import logoDesktop from "../../assets/logo-dark.svg";

const LogoTitle = () => {
  return (
    <div className={container}>
      <img src={logoDesktop} alt="Spotlight Logo" />
    </div>
  );
};

export default LogoTitle;

const container = css`
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 34px;
  
  h1 {
    font-weight: normal;
    font-size: ${textSizes.title};
    color: ${colors.titleColor};
    margin-left: 10px;
  }
  
  img {
      max-height: 34px;
      position: relative;
      top: 3px;
    }
  
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    padding: ${boxStyles.desktopPadding};

    h1 {
      font-size: ${textSizes.subtitle};
    }
  }
`;
